module.exports = __webpack_public_path__ + "img/3x.170c5a9.jpg";